// src/App.js
import React, { useState, Suspense } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock } from 'lucide-react';

// --- IMPORTAÇÃO DOS COMPONENTES DE LAYOUT (Do arquivo único que criamos) ---
import { 
  Header, 
  PremiumHero, 
  Footer, 
  FloatingWhatsAppButton 
} from './pages/Layout';

// --- IMPORTAÇÃO DINÂMICA DAS PÁGINAS (Lazy Loading) ---
const AboutPage = React.lazy(() => import('./pages/AboutPage'));
const ServicesPage = React.lazy(() => import('./pages/ServicesPage'));
const ProjectGallery = React.lazy(() => import('./pages/projectData'));
const ReviewsPage = React.lazy(() => import('./pages/ReviewsPage'));
const MaintenanceRequestPage = React.lazy(() => import('./pages/MaintenanceRequestPage'));
const MaintenancePage = React.lazy(() => import('./pages/MaintenancePage'));

// Componente de Loading (Spinner)
const LoadingSpinner = () => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] w-full bg-[#061829]">
    <motion.div 
      animate={{ rotate: 360 }} 
      transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
      className="mb-4"
    >
      <Clock size={48} color="#8ad7f7" />
    </motion.div>
    <p className="text-white font-medium text-sm animate-pulse">Carregando...</p>
  </div>
);

export default function TopLuxSolar() {
  const [currentPage, setCurrentPage] = useState('home');

  // Função para renderizar a página corretFFD700a
  const renderPageContent = () => {
    switch (currentPage) {
      case 'home':
        return (
          <>
            <PremiumHero setCurrentPage={setCurrentPage} />
            {/* Carrega o restante da home sob demanda para ser rápido */}
            <Suspense fallback={<div className="py-20 text-center">Carregando...</div>}>
               <ServicesPage />
               <ProjectGallery />
            </Suspense>
          </>
        );
      case 'about': return <AboutPage />;
      case 'services': return <ServicesPage />;
      case 'gallery': return <ProjectGallery />;
      case 'reviews': return <ReviewsPage />;
      case 'maintenance': return <MaintenanceRequestPage />;
      case 'system-maintenance': return <MaintenancePage />;
      default: return <PremiumHero setCurrentPage={setCurrentPage} />;
    }
  };

  return (
    <div className="min-h-screen font-sans antialiased bg-white">
      
      {/* O Header aparece em todas, menos na tela de manutenção do sistema */}
      {currentPage !== 'system-maintenance' && (
        <Header currentPage={currentPage} setCurrentPage={setCurrentPage} />
      )}

      <main>
        <AnimatePresence mode="wait">
          <motion.div
            key={currentPage}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            <Suspense fallback={<LoadingSpinner />}>
              {renderPageContent()}
            </Suspense>
          </motion.div>
        </AnimatePresence>
      </main>

      {currentPage !== 'system-maintenance' && (
        <>
          <Footer setCurrentPage={setCurrentPage} />
          <FloatingWhatsAppButton />
        </>
      )}
    </div>
  );
}